import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from 'react';
import Client from '@twilio/conversations';

import Room from './Room';
import { videoChatStyles } from '../styles/togetherPageStyles';
import useWindowDimensions from '../theme/useWindowDimensions';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import PeopleIcon from '@material-ui/icons/People';
import MicOffSharpIcon from '@material-ui/icons/MicOffSharp';
import VideocamOffSharpIcon from '@material-ui/icons/VideocamOffSharp';
import VolumeOffSharpIcon from '@material-ui/icons/VolumeOffSharp';
import {
  Token,
  TwilioConnect,
  VideoNBoxChatToken,
} from '../services/twilioServices';

import RoomContext from '../services/roomContext';
import toast, { Toaster } from 'react-hot-toast';

import VideocamSharpIcon from '@material-ui/icons/VideocamSharp';
import MicSharpIcon from '@material-ui/icons/MicSharp';
import VolumeUpSharpIcon from '@material-ui/icons/VolumeUpSharp';

import { getUserBrowserStorage } from '../constants';
import { getAndUpdateNewRoomChatToken } from './roomChat/roomChatFuncs';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => videoChatStyles(theme));

const VideoChat = (props) => {
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const userId = userDetails?.userId;
  const { rooms, setRooms } = useContext(RoomContext);
  const [boxConversations, setBoxConversations] = useState(null);
  const [boxChatSid, setBoxChatSid] = useState('');
  const streamInfo = useSelector((state) => state.streamInfo);
  const movingBox = useSelector((state) => state.movingBox);

  const classes = useStyles();
  const elRefRen = useRef(null);
  const elRefChange = useRef(null);
  const [showPop, setShowPop] = useState(false);
  const [showBoxList, setShowBoxList] = useState(false);

  const { height } = useWindowDimensions();
  const room = rooms.activeBoxRoom;

  const inactiveClr = '#fff'; //8E878 --old
  const actvClr = '#ffffff';
  const [iconColor, setIconColor] = useState({
    mic: inactiveClr,
    video: inactiveClr,
    speaker: inactiveClr,
    people: inactiveClr,
    msg: inactiveClr,
    change: inactiveClr,
    speakerMute: false,
    videoMute: false,
    micMute: false,
  });

  const handleLogout = useCallback(() => {
    disconnectRoom();
  }, []);

  const muteMicOnJoin = useCallback(() => {
    room?.localParticipant?.tracks.forEach((trackPub) => {
      if (trackPub?.track?.kind === 'audio') {
        if (trackPub?.track?.isEnabled === true) {
          trackPub.track.disable();
          trackPub.track.stop();
          setIconColor((prevState) => {
            return {
              ...prevState,
              mic: actvClr,
              micMute: true,
            };
          });
        }
      }
    });
  }, [room]);

  const muteVideoOnJoin = useCallback(() => {
    room?.localParticipant?.tracks.forEach((trackPub) => {
      if (trackPub?.track?.kind === 'video') {
        if (trackPub?.track?.isEnabled === true) {
          trackPub.track.disable();
          trackPub.track.stop();
          setIconColor((prevState) => {
            return {
              ...prevState,
              video: actvClr,
              videoMute: true,
            };
          });
        }
      }
    });
  }, [room]);

  useEffect(() => {
    //this code joins a participant into room with their audio, video muted. happens for change room also
    muteVideoOnJoin();
    muteMicOnJoin();
  }, [room]);

  const onClickMicIcon = useCallback(() => {
    room?.localParticipant?.tracks.forEach((trackPub) => {
      if (trackPub?.track?.kind === 'audio') {
        if (trackPub?.track?.isEnabled === false) {
          trackPub.track.enable();
          trackPub.track.restart();
          setIconColor((prevState) => {
            return {
              ...prevState,
              mic: inactiveClr,
              micMute: false,
            };
          });
        } else if (trackPub?.track?.isEnabled === true) {
          trackPub.track.disable();
          trackPub.track.stop();
          setIconColor((prevState) => {
            return {
              ...prevState,
              mic: actvClr,
              micMute: true,
            };
          });
        }
      }
    });
  }, [room]);

  const onClickVideoIcon = useCallback(() => {
    room?.localParticipant?.tracks.forEach((trackPub) => {
      if (trackPub?.track?.kind === 'video') {
        if (trackPub?.track?.isEnabled === false) {
          trackPub.track.enable();
          trackPub.track.restart();
          setIconColor((prevState) => {
            return {
              ...prevState,
              video: inactiveClr,
              videoMute: false,
            };
          });
        } else if (trackPub?.track?.isEnabled === true) {
          trackPub.track.disable();
          trackPub.track.stop();
          setIconColor((prevState) => {
            return {
              ...prevState,
              video: actvClr,
              videoMute: true,
            };
          });
        }
      }
    });
  }, [room]);

  const onClickPeopleIcon = useCallback(() => {
    setShowPop((prevState) => !prevState);
  }, []);

  useEffect(() => {
    if (boxConversations) {
      boxConversations.on('connectionStateChanged', async (state) => {});

      boxConversations.on('tokenAboutToExpire', (p) => {
        console.log(p, 'after token expired twilio local conv');
        alert('local token expired');
        getAndUpdateNewRoomChatToken(
          streamInfo.userId,
          movingBox.currBoxChatSid,
          streamInfo.participantName,
          boxConversations
        );
      });

      boxConversations.on('conversationJoined', (conversation) => {
        if (conversation.sid === boxChatSid) {
          setRooms((prevState) => {
            return { ...prevState, activeBConversation: conversation };
          });
        }
      });
    }

    return () => {
      if (boxConversations) {
        boxConversations.off('connectionStateChanged', async (state) => {});

        boxConversations.off('tokenAboutToExpire', (p) => {
          console.log(p, 'after token expired twilio local conv');
          alert('local token expired');
          getAndUpdateNewRoomChatToken(
            streamInfo.userId,
            movingBox.currBoxChatSid,
            streamInfo.participantName,
            boxConversations
          );
        });

        boxConversations.off('conversationJoined', (conversation) => {
          if (conversation.sid === boxChatSid) {
            setRooms((prevState) => {
              return { ...prevState, activeBConversation: conversation };
            });
          }
        });
      }
    };
  }, [boxConversations, boxChatSid, movingBox]);

  const handleTwilioConnect = async (
    userId,
    roomName,
    connectRoom,
    activeRoom,
    activeDataTrack,
    participants,
    toastId,
    chatSID,
    participantName
  ) => {
    toast.loading('Please wait, Changing table..', { id: toastId });

    // const token = await Token(userId, roomName, chatSID, participantName);
    const [videoToken, boxChatToken] = await VideoNBoxChatToken(
      userId,
      roomName,
      chatSID,
      participantName
    );
    toast.loading('Please wait, Changing table..', { id: toastId });

    if (!(videoToken && boxChatToken)) {
      toast.dismiss();
      toast.error('Table Change Error!', { id: toastId });
      return null;
    }

    const twilioConnect = await connectRoom(videoToken, roomName);

    const boxConversations = await Client.create(boxChatToken);
    if (twilioConnect?.success) {
      setRooms((prevState) => {
        return {
          ...prevState,
          [activeRoom]: twilioConnect.room,
        };
      });
      setBoxConversations(boxConversations);
      toast.dismiss();
      toast.success('Table changed successfully', { id: toastId });
    } else {
      toast.dismiss();
      toast.error('Table Change Error!', { id: toastId });
    }
  };

  const disconnectRoom = useCallback(() => {
    rooms.activeBConversation?.leave();
    room?.disconnect();
  }, [room, rooms]);

  const handleRoomChange = useCallback(
    (boxRoomName, chatSID, toastId, participantName) => {
      toast.dismiss();
      disconnectRoom();
      toast.loading('Please wait, Changing table..', { id: toastId });
      setIconColor((prevState) => {
        return {
          ...prevState,
          mic: inactiveClr,
          micMute: false,
          video: inactiveClr,
          videoMute: false,
        };
      });
      setBoxChatSid(chatSID);
      handleTwilioConnect(
        userId,
        boxRoomName,
        TwilioConnect,
        'activeBoxRoom',
        'activeBoxDataTrack',
        'boxParticipants',
        toastId,
        chatSID,
        participantName
      );
    },
    []
  );

  const showBoxesModal = (prevState) => {
    setShowBoxList(true);
    return { ...prevState, change: '#fff' };
  };
  const hideBoxesModal = (prevState) => {
    setShowBoxList(false);
    return { ...prevState, change: inactiveClr };
  };

  const onClickChangeIcon = useCallback(() => {
    setIconColor((prevState) => {
      const temp =
        prevState.change === inactiveClr
          ? showBoxesModal(prevState)
          : hideBoxesModal(prevState);
      return temp;
    });
  }, [room]);

  const onClickSpeakerIcon = useCallback(() => {
    setIconColor((prevState) => {
      return prevState.speaker === actvClr
        ? { ...prevState, speaker: inactiveClr, speakerMute: false }
        : { ...prevState, speaker: actvClr, speakerMute: true };
    });
  }, [room]);

  useEffect(() => {
    setRooms((prevState) => {
      return { ...prevState, handleRoomChange: handleRoomChange };
    });
  }, []);

  let render;
  if (room) {
    render = (
      <div
        className={classes.root}
        style={{ height: '100%' }} // height: height * 0.43
      >
        <Room
          room={room}
          handleLogout={handleLogout}
          controls={iconColor}
          showList={showPop}
          hideParticipantsListModal={onClickPeopleIcon}
          elRefRen={elRefRen}
          elRefChange={elRefChange}
          showBoxList={showBoxList}
          hideBoxesModal={onClickChangeIcon}
          handleRoomChange={handleRoomChange}
        />
      </div>
    );
  } else {
    render = (
      <div
        className={classes.root}
        // style={{ height: height * 0.43, overflowY: 'scroll' }}
      >
        <p>Please wait.. loading video chat now...</p>
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
      {render}
      <Box
        display='flex'
        justifyContent='space-evenly'
        alignItems='center'
        height={height * 0.05}
        minHeight='40px'
        className={classes.boxControls}
      >
        {/* <IconButton onClick={onClickPeopleIcon} id="seepop" ref={elRefRen}>
          <PeopleIcon style={{ color: iconColor.people }} />
        </IconButton> */}
        <IconButton onClick={onClickMicIcon}>
          {iconColor.micMute ? (
            <MicOffSharpIcon style={{ color: iconColor.mic }} />
          ) : (
            <MicSharpIcon style={{ color: iconColor.mic }} />
          )}
        </IconButton>
        <IconButton onClick={onClickVideoIcon}>
          {iconColor.videoMute ? (
            <VideocamOffSharpIcon style={{ color: iconColor.video }} />
          ) : (
            <VideocamSharpIcon style={{ color: iconColor.video }} />
          )}
        </IconButton>

        <IconButton onClick={onClickSpeakerIcon}>
          {iconColor.speakerMute ? (
            <VolumeOffSharpIcon style={{ color: iconColor.speaker }} />
          ) : (
            <VolumeUpSharpIcon style={{ color: iconColor.speaker }} />
          )}
        </IconButton>
      </Box>
      <Toaster position='top-center'></Toaster>
    </div>
  );
};

export default VideoChat;
